/* Validated public application. Versioned intake stores full answers and returns explicit customer-operation status. Pending account creation is retried with the same submission UUID. */
(function () {
  'use strict';

  /* the store's forms, posted the way the store expects (spam protection on): a fresh copy of the form, the CAPTCHA token attached
     through window.Shopify.captcha.protect, submitted into a hidden frame so the page stays put. A bare fetch carries no token and
     the store answers with its challenge page instead of sending. Shared: window.stellarPost. */
  var sxPostN = 0;
  function sxPostImpl(src, fields, opts) {
    opts = opts || {};
    return new Promise(function (resolve) {
      if (!src) { resolve({ ok: false }); return; }
      var form = src.cloneNode(true); form.removeAttribute('id'); form.hidden = true; form.setAttribute('data-post-copy', '');
      Object.keys(fields || {}).forEach(function (k) { var el = form.elements[k]; if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = k; form.appendChild(el); } el.value = fields[k] == null ? '' : fields[k]; });
      var name = 'stellar-post-' + (++sxPostN), fr = document.createElement('iframe');
      fr.name = name; fr.setAttribute('aria-hidden', 'true'); fr.setAttribute('sandbox', 'allow-same-origin allow-forms'); fr.tabIndex = -1; fr.style.cssText = 'position:absolute;width:0;height:0;border:0;opacity:0;pointer-events:none';
      form.target = name; document.body.appendChild(fr); document.body.appendChild(form);
      var done = false, timer = setTimeout(function () { finish({ ok: false, timeout: true }); }, opts.timeout || 12000);
      function finish(res) { if (done) return; done = true; clearTimeout(timer); resolve(res); setTimeout(function () { try { form.remove(); fr.remove(); } catch (e) { } }, 1500); }
      fr.addEventListener('load', function () {
        var url = null; try { url = fr.contentWindow.location.href || ''; } catch (e) { url = null; }
        if (url === null) { finish({ ok: true, unknown: true }); return; }
        if (!url || url === 'about:blank') return;
        var ch = /\/challenge/.test(url); finish({ ok: !ch, challenged: ch, url: url });
      });
      function go() { try { form.submit(); } catch (e) { finish({ ok: false }); } }
      var cap = window.Shopify && window.Shopify.captcha;
      if (cap && typeof cap.protect === 'function') {
        var went = false, wait = setTimeout(function () { if (!went) { went = true; go(); } }, 5000);
        try { cap.protect(form, function () { if (went) return; went = true; clearTimeout(wait); go(); }); } catch (e) { if (!went) { went = true; clearTimeout(wait); go(); } }
      } else go();
    });
  }
  window.stellarPost = window.stellarPost || sxPostImpl;
  function sxPost(src, fields, opts) { return window.stellarPost(src, fields, opts); }
  /* a visible submit with the token attached (the page leaves): for the store's own customer and contact forms */
  function sxSubmit(form) {
    var cap = window.Shopify && window.Shopify.captcha, went = false, go = function () { if (went) return; went = true; try { form.submit(); } catch (e) { } };
    if (cap && typeof cap.protect === 'function') { setTimeout(go, 5000); try { cap.protect(form, go); } catch (e) { go(); } } else go();
  }
  function trk(event, data, opts) { if (window.stellar && window.stellar.track) return window.stellar.track(event, data, opts); }
  /* Public and signed-in applications use the same durable server workflow. */
  function label(name) { return String(name).replace(/^customer\[note\]\[|^customer\[|^contact\[|\]$/g, '').trim(); }

  /* stepped form: options advance on their own, typed steps need Next, the last step submits */
  function stepped(root) {
    if (root.dataset.sxbOn) return; root.dataset.sxbOn = '1';
    var f = root.tagName === 'FORM' ? root : root.querySelector('form'); if (!f) return;
    var steps = Array.prototype.slice.call(f.querySelectorAll('.step')), last = steps.length, i = 0;
    var back = f.querySelector('[data-back]'), next = f.querySelector('[data-next]'), submit = f.querySelector('[data-submit]'), bar = f.querySelector('.bar i');
    if (!steps.length || !next || !submit) return;
    if (root.hasAttribute('data-application')) { f.setAttribute('data-application', ''); if (root.getAttribute('data-klaviyo-list')) f.setAttribute('data-klaviyo-list', root.getAttribute('data-klaviyo-list')); if (!f.querySelector('input[type=password]')) f.setAttribute('data-klaviyo-off', ''); }
    var advanceTimer = null;
    function cancelAdvance() {
      if (advanceTimer !== null) { clearTimeout(advanceTimer); advanceTimer = null; }
    }
    function queueAdvance(input) {
      cancelAdvance();
      var expected = i, step = steps[i];
      if (!step || !step.contains(input) || i >= last - 1) return;
      advanceTimer = setTimeout(function () {
        advanceTimer = null;
        if (i === expected && steps[i] === step && !step.hidden && input.checked && valid()) show(expected + 1);
      }, 260);
    }
    function show(n) { cancelAdvance();
      i = Math.max(0, Math.min(n, last - 1)); steps.forEach(function (st, k) { st.hidden = k !== i; });
      var lastQ = i === last - 1;
      if (back) back.hidden = i === 0; next.hidden = lastQ; submit.hidden = !lastQ;
      if (bar) bar.style.width = Math.round(((i + 1) / last) * 100) + '%';
      var el = steps[i].querySelector('input:not([type=radio]):not([type=checkbox]):not([type=hidden]),textarea'); if (el && i > 0) setTimeout(function () { try { el.focus({ preventScroll: true }); } catch (e) {} }, 350);
      trk('form_step_viewed', { form: f.id || 'form', step: i + 1, of: last, question: (steps[i].querySelector('.q') || {}).textContent || '' }, { el: f });
    }
    function valid(){return window.stellar.formAdapters.validate(steps[i]);}
    f.addEventListener('change', function (e) {
      if (e.target.type === 'radio') {
        trk('form_answered', { form: f.id || 'form', step: i + 1, question: label(e.target.name), answer: e.target.value }, { el: f });
        if (i < last - 1) queueAdvance(e.target);
      }
    });
    next.addEventListener('click', function () { if (valid()) show(i + 1); });
    if (back) back.addEventListener('click', function () { show(i - 1); });
    var x0 = null;
    f.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    f.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 60) return; if (dx < 0 && i < last - 1 && valid()) show(i + 1); if (dx > 0 && i > 0) show(i - 1); }, { passive: true });
    var adapter=window.stellar.formAdapters;
    var intakeId=f.id==='event-add'?'event_creation_request':'ambassador_application';
    adapter.bind({form:f,button:submit,formId:intakeId,
      isFinalStep:function(){return i===last-1;},nextStep:function(){if(valid())show(i+1);},
      validate:function(){for(var k=0;k<last;k++){show(k);if(!valid())return false;}return true;},
      payload:function(){
        
        var p=adapter.fromForm(f,intakeId,{includeHidden:true,purpose:f.id==='event-add'?'operational':'lead'});
        delete p.fields.body;delete p.field_labels.body;
        return p;
      },
      isComplete:function(receipt){return intakeId==='event_creation_request'||adapter.applicationComplete(receipt);},
      onAccepted:async function(receipt){
        if(intakeId==='event_creation_request')adapter.showSaved(f,'Thank you — your request has been received.');
        else adapter.applicationReceipt(f,submit,receipt);
      }
    });
    show(root.querySelector('.errors') ? last - 1 : 0);
  }

  /* the application: file the labelled answers in the warehouse and Klaviyo before the page posts to Shopify.
     The form carries a password, so the data layer's own form capture leaves it alone; this is the one place it is recorded. */

  function subnav(nav) {
    if (nav.dataset.sxbOn || !('IntersectionObserver' in window)) return; nav.dataset.sxbOn = '1';
    var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (!en.isIntersecting) return; links.forEach(function (a) { a.classList.toggle('on', a.getAttribute('href') === '#' + en.target.id); }); });
    }, { rootMargin: '-40% 0px -55% 0px' });
    links.forEach(function (a) { var t = document.getElementById(a.getAttribute('href').slice(1)); if (t) io.observe(t); });
  }

  /* room forms (availability, an offer, a guest count, the profile): a Shopify contact form, sent in place.
     The answer is recorded in the warehouse with every field labelled, then posted to the store inbox for the desk.
     If the in-place post fails, the form submits the ordinary way and the page reloads with Shopify's own message. */
  function roomForm(wrap) {
    var f=wrap.tagName==='FORM'?wrap:wrap.querySelector('form');if(!f||f.dataset.sxbOn)return;f.dataset.sxbOn='1';
    var adapter=window.stellar.formAdapters,id=(wrap.getAttribute('data-event')||f.id||'ambassador_request').toLowerCase().replace(/[^a-z0-9]+/g,'_').replace(/^_|_$/g,'');
    adapter.bind({form:f,button:f.querySelector('button[type=submit]')||f.querySelector('button'),formId:id,
      validate:function(){return adapter.validate(f);},
      payload:function(sub){var p=adapter.fromForm(f,id,{includeHidden:true,purpose:'operational'});if(sub&&sub.name)p.fields.submitted_action=sub.value;return p;},
      onAccepted:function(){adapter.showSaved(f,'Your request has been received for review.');}
    });
  }
  function done(f, sub, msg) {
    var row = f.closest('tr');
    if (row) {
      var st = row.querySelector('.sxv-status'), acts = row.querySelector('.acts');
      if (st && sub && sub.getAttribute('data-status')) { st.className = 'sxv-status ' + (sub.getAttribute('data-status-class') || ''); st.textContent = sub.getAttribute('data-status'); }
      if (acts) acts.innerHTML = '<span class="sent">' + msg + '</span>';
      if (sub && sub.hasAttribute('data-dim')) row.style.opacity = '.4';
      return;
    }
    var send = f.querySelector('.send'), m = document.createElement('p'); m.className = 'msg'; m.textContent = msg;
    if (send) { send.hidden = true; send.parentNode.insertBefore(m, send); } else f.appendChild(m);
  }

  /* availability: tap an evening to mark it; the marked dates travel in a hidden field */
  function calendar(cal) {
    if (cal.dataset.sxbOn) return; cal.dataset.sxbOn = '1';
    var out = cal.parentElement.querySelector('[data-cal-out]'), month = cal.getAttribute('data-month') || '';
    function sync() {
      var days = Array.prototype.slice.call(cal.querySelectorAll('button.on')).map(function (b) { return b.textContent.trim(); });
      if (out) out.value = days.length ? month + ': ' + days.join(', ') : month + ': none';
    }
    cal.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { if (b.disabled) return; b.classList.toggle('on'); sync(); }); });
    sync();
  }

  /* profile: the card updates as you type; the bio keeps to its word count */
  function profile(root) {
    if (root.dataset.sxbOn) return; root.dataset.sxbOn = '1';
    var max = parseInt(root.getAttribute('data-words') || '60', 10);
    root.querySelectorAll('[data-in]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var out = root.querySelector('[data-out="' + inp.dataset.in + '"]'); if (out) out.textContent = inp.value;
        if (inp.dataset.in === 'bio') { var n = inp.value.trim().split(/\s+/).filter(Boolean).length, c = root.querySelector('[data-count]'); if (c) { c.textContent = n + ' ' + (c.getAttribute('data-words-label') || 'words') + ' · ' + (c.getAttribute('data-upto') || 'up to') + ' ' + max; c.style.color = n > max ? '#c66' : ''; } }
      });
    });
  }

  function init(root) {
    if (root.matches('[data-steps]')) stepped(root); else root.querySelectorAll('[data-steps]').forEach(stepped);
    root.querySelectorAll('[data-subnav]').forEach(subnav);
    root.querySelectorAll('[data-room-form]').forEach(roomForm);
    root.querySelectorAll('[data-cal]').forEach(calendar);
    if (root.matches('[data-profile]')) profile(root); else root.querySelectorAll('[data-profile]').forEach(profile);
  }
  function boot() { document.querySelectorAll('[data-sxb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-sxb]').forEach(init); });
})();
